import { InputAdornment } from '@mui/material'
import { Field } from 'formik'
import { NumberInputProps } from '../inputs/NumberInput'
import { TextField, TextFieldProps } from './TextField'

interface NumberInputFieldProps extends Partial<TextFieldProps>, NumberInputProps {
  name: string
  error?: boolean
}

export const NumberInputField = ({
  name,
  unit,
  style,
  disabled,
  label,
  error,
  ...textFieldProps
}: NumberInputFieldProps) => (
  <Field
    component={TextField}
    name={name}
    error={error}
    InputProps={{
      disabled,
      type: 'number',
      inputProps: textFieldProps,
      endAdornment: unit ? <InputAdornment position="end">{unit}</InputAdornment> : undefined,
    }}
    label={label}
    style={style}
  />
)
